<template>
  <div class="form-container">
    <el-form class="public-big-form" ref="form" :model="form" :rules="rules">
      <el-form-item prop="student_name">
        <el-input v-model="form.student_name" :error="formError.student_name" size="small" placeholder="请输入姓名"></el-input>
      </el-form-item>
      <el-form-item>
        <el-radio-group v-model="type" @change="handleChange">
          <el-radio-button :label="1">证件号</el-radio-button>
          <el-radio-button :label="2">证书编号</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item prop="id_num" v-if="type === 1">
        <el-input v-model="form.id_num" :error="formError.id_num" size="small" placeholder="请输入证件号"></el-input>
      </el-form-item>
      <el-form-item prop="certificate_code" v-if="type === 2">
        <el-input v-model="form.certificate_code" :error="formError.certificate_code" size="small" placeholder="请输入证书编号"></el-input>
      </el-form-item>
      <el-form-item prop="captcha_value">
        <el-row :gutter="12">
          <el-col :span="12">
            <el-input v-model="form.captcha_value" size="small" placeholder="请输入计算结果" clearable @keyup.native.enter="query"></el-input>
          </el-col>
          <el-col :span="8">
            <div class="captcha-wrapper" @click="getCaptcha">
              <img :src="captcha_img" alt title="点击更换验证码" />
            </div>
          </el-col>
          <el-col :span="4">
            <span @click="getCaptcha" style="cursor:pointer">更换</span>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="query" :loading="loading">查询</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { captcha } from "@/api/user";
export default {
  data() {
    return {
      type: 1,
      form: {
        student_name: "",
        id_num: "",
        certificate_code: "",
        captcha_key: "",
        captcha_value: "",
      },
      captcha_img: "",
      rules: {
        student_name: [
          {
            required: true,
            message: "姓名不能为空",
            trigger: "blur",
          },
        ],
        id_num: [
          {
            required: true,
            message: "身份证号不能为空",
            trigger: "blur",
          },
        ],
        certificate_code: [
          {
            required: true,
            message: "证书编号不能为空",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {},
  props: {
    formError: {
      type: Object,
      default() {
        return {};
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.getCaptcha();
  },
  methods: {
    handleChange() {
      this.$refs.form.resetFields();
      this.form.id_num = "";
      this.form.certificate_code = "";
    },
    query() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$emit("on-query", this.form);
        } else {
          this.$notify.error({
            message: "请检查输入",
          });
          return false;
        }
      });
    },
    getCaptcha() {
      this.form.captcha_key = "";
      this.form.captcha_value = "";
      captcha().then((res) => {
        if (res && res.code === 200) {
          this.captcha_img = res.data.img;
          this.form.captcha_key = res.data.key;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.form-container {
  border: 1px solid #eaeaea;
  padding: 40px 0;
  margin-top: 20px;
  .public-big-form {
    width: 60%;
    margin: 0 auto;
  }
}
@media screen and (max-width: 768px) {
  .form-container {
    padding: 20px 0;
    .public-big-form {
      width: 90%;
    }
  }
}
</style>
